var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "non-blocking-modal" }, [
    _c("div", { staticClass: "row mb-2" }, [
      _c("div", { staticClass: "col" }, [
        _c("h4", [_vm._v("Job updates")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "l-modal-close",
            on: {
              click: function($event) {
                _vm.$emit("close")
              }
            }
          },
          [_vm._m(0)]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _vm.loading
            ? [
                _c(
                  "vue-content-loading",
                  { attrs: { width: 420, height: 100 } },
                  _vm._l(2, function(x) {
                    return _c("rect", {
                      key: x,
                      attrs: {
                        x: "10",
                        y: 10 * x * 3,
                        rx: "3",
                        ry: "3",
                        width: "400",
                        height: "15"
                      }
                    })
                  })
                )
              ]
            : _vm._l(_vm.changes, function(change) {
                return _c("p", { key: change.id }, [_vm._v(_vm._s(change))])
              })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [_c("error-field", { attrs: { errors: _vm.errors, field: "note" } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _vm.sending
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary pull-right ld-ext-right",
                attrs: { type: "button" },
                on: { click: _vm.sendUpdateEmail }
              },
              [
                _vm._v("\n        Send email with updates\n        "),
                _c("div", { staticClass: "ld ld-ball ld-flip" })
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "btn btn-close" }, [
      _c("span", { staticClass: "mod-icon-close opacity-50" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0279fc46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0279fc46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/modals/JobChanges.vue
// module id = null
// module chunks = 